import React from 'react';
import { ModuleConfig } from '../../types/ModuleConfig';
import { getColor } from '../../brandConfig';
const Learning = React.lazy(() => import('./ValueLearning'));
const Guide = React.lazy(() => import('./ValueGuide'));
const valueLiteracyModuleConfig: ModuleConfig = {
  id: 'value-literacy', name: 'Money, Work & Value', description: 'Learn how money and work-linked credits arise, circulate and relate to human and environmental outcomes',
  version: '0.1.0', enabled: true, category: 'business', order: 16, icon: '🌱', color: getColor('primary'),
  routes: [{ path: '/value-literacy', component: Learning, public: true, useLayout: true }, { path: '/value-literacy/guide', component: Guide, public: true, useLayout: true }],
  navigation: [{ label: 'Learn and explore', path: '/value-literacy', permissionLevel: 'view', icon: '🌱' }, { label: 'Printable guide', path: '/value-literacy/guide', permissionLevel: 'view', icon: '📖' }],
  permissions: { view: [], create: [], edit: [], delete: [] },
};
export default valueLiteracyModuleConfig;
